var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-7 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.816
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    strokeWidth: 0.00032,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set",
    transform: "translate(-471.000000, -463.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487,468 L473,468 L473,467 C473,465.896 473.896,465 475,465 L485,465 C486.104,465 487,465.896 487,467 L487,468 L487,468 Z M473,470 L487,470 L487,483 L473,483 L473,470 Z M487,491 C487,492.104 486.104,493 485,493 L475,493 C473.896,493 473,492.104 473,491 L473,485 L487,485 L487,491 L487,491 Z M485,463 L475,463 C472.791,463 471,464.791 471,467 L471,491 C471,493.209 472.791,495 475,495 L485,495 C487.209,495 489,493.209 489,491 L489,467 C489,464.791 487.209,463 485,463 L485,463 Z M480,491 C481.104,491 482,490.104 482,489 C482,487.896 481.104,487 480,487 C478.896,487 478,487.896 478,489 C478,490.104 478.896,491 480,491 L480,491 Z",
    id: "smartphone"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPhone);
export default __webpack_public_path__ + "static/media/smartPhone.bd19a0316848a19b2abb809709cda9e3.svg";
export { ForwardRef as ReactComponent };